export default __webpack_public_path__ + "static/media/leave.9bac481b.svg";